import React,{useRef, useState, useEffect} from "react";
import '../../styles/NavBar.css';
import { NavLink } from "react-router-dom"; 
import {FaTimes, FaBars} from 'react-icons/fa';
import {AiOutlineHome, AiOutlineUser, AiOutlineFundProjectionScreen, AiOutlineTrophy} from 'react-icons/ai';
import {CgFileDocument} from 'react-icons/cg';

const NavBar=()=>{
    const NavRef=useRef();

    const NavHide=()=>{
        NavRef.current.classList.toggle('responsiveNav');
    }

    const CloseNav=()=>{
        NavRef.current.classList.remove('responsiveNav');
    }

    const [scrolling, setScrolling]=useState(false);
    const handleScroll=()=>{
        if(window.scrollY>130){
            setScrolling(true);
        }
        else{
            setScrolling(false);
        }
    };

    useEffect(()=>{
        window.addEventListener("scroll",handleScroll);
        return()=>{
            window.removeEventListener("scroll", handleScroll);
        }
    });

    return(
        <header className={scrolling ? "scrolled" :""   }>
            <div className="navMenu">
            <h3>A.KG</h3>
            <nav ref={NavRef}>
                <ul className="navLink">
                <li><AiOutlineHome/><NavLink to='/' onClick={CloseNav}>Home</NavLink></li>
                <li><AiOutlineUser/><NavLink to='/about' onClick={CloseNav}>About</NavLink></li>
                <li><AiOutlineFundProjectionScreen/><NavLink to='/projects' onClick={CloseNav}>Projects</NavLink></li>
                <li><AiOutlineTrophy/><NavLink to='/achievements' onClick={CloseNav}>Achievements</NavLink></li>
                <li><CgFileDocument/><NavLink to='/Resume' onClick={CloseNav}>Resume</NavLink></li>
                </ul>
                <button className="navButton navCloseButton" onClick={NavHide}><FaTimes/></button>
            </nav>
                <button className="navButton" onClick={NavHide}><FaBars/></button>
                </div>
        </header>
    )
}

export default NavBar;